import { _APP_CONFIG } from "../../core/config/AppConfig";
import { ArrayV2 } from "../../util/ArrayV2";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { DataUtil } from "../util/Util";

import { MEscuela } from "../model/MEscuela";
import IFinanzaItemHoraExtra = Entidad.IFinanzaItemHoraExtra;

export const _DICC_HORAS_EXTRAS: Map<number, IFinanzaItemHoraExtra> = new Map();

/** Diccionario extra (IMPORTANTE: USO SOLO DE MAINPAGE):
 * * Map<idAlumno, asignaciones<Map<idAsignacion, dataIFinanzaItemHoraExtra>>> */
export var _DICC_HORAS_EXTRAS_BY_ALUMNO: Map<number, Map<number, IFinanzaItemHoraExtra>> = new Map();

const IDREQUEST = Entidad.CTipoRequest.FinanzaHoraExtra;

export function _SvFinanzasObtenerListaHorasExtra(escuelas: MEscuela[]): Promise<DataDRequest.IRequestResponseListA<IFinanzaItemHoraExtra>[]> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerListaHorasExtra";
    return new ArrayV2<MEscuela>()
        ._Push(...escuelas)
        ._MapAwait(async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(IDREQUEST, IdKinder);
            const params = {
                "IdEscuela": IdKinder,
                "Modificacion": currentDateStr,
            }
            return DataDRequest._Request4List(url, "GET", params, IDREQUEST, IdKinder);
        });
}

interface IItemHoraPago {
    IdCargo: number;
    Ids: Array<number>;
    Valor: number;
    NombreCargo: string;
}
export async function _SvFinanzaHoraExtraGenerarCargo(idAlumno: number, idCuenta: number, idCicloEscolar: number, fAplicacion: Date, entradas: IItemHoraPago, salidas: IItemHoraPago): Promise<DataDRequest.IRequestResponseA<number[]>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/HorasExtraGenerarCargo";
    const params = {
        IdAlumno: idAlumno,
        IdCuenta: idCuenta,
        IdCicloEscolar: idCicloEscolar,
        IdUsuario: DataUtil._Usuario.IdUsuario,
        FechaInicio: fAplicacion.toISOString(), // "2021-06-05T01:00:00Z",
        Entradas: entradas || null,
        Salidas: salidas || null,
        // {
        //     IdCargo: 77,
        //     Ids: [7],
        //     Valor: 150
        // }
    }
    return DataDRequest._Request5<number[]>(url, "POST", params)
}

export async function _SvFinanzaHoraExtraIgnorarRegistro(idsTiempoExtra: Array<number>): Promise<DataDRequest.IRequestResponseA<number[]>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/IgnorarRegistro";
    const params = {
        "IdTiempoExtra": idsTiempoExtra,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5<number[]>(url, "POST", params)
}
